import React, { Component } from 'react';
import { Link } from 'react-router';
import IdleTimer from 'react-idle-timer';
import moment from 'moment';
import Cookies from 'universal-cookie';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePickerCustom from '../containers/date_range_picker';
import MenuCustom from '../components/menu_custom';
import VerticalNavbar from '../components/verticalNavbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetch_queryInfo, menuSetting } from '../actions/index';
import { userLogout } from '../utility/logout';
import 'react-notifications/lib/notifications.css';
import "../styles/App.css";
import '../styles/hamburger.css';
import '../styles/verticalNavbar.css';
import '../styles/insertPopUp.css';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import Dialog from 'material-ui/Dialog';
import { NotificationContainer } from 'react-notifications';
import $ from 'jquery';

let cookies = new Cookies();

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      titleName: "分析設定",
      open: false,
      docked: false,
      scrollTop: 0,
      gotopIsClicked: false,
      timeout: 3600000,
      autoLogout: false,
    }
    this.updateDimensions = this.updateDimensions.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.scrollToTop = this.scrollToTop.bind(this)
    this.handleTouchMap = this.handleTouchMap.bind(this)
    this.onActive = this.onActive.bind(this)
    this.onIdle = this.onIdle.bind(this)
  }

  componentWillReceiveProps(nextProps){
    if(this.state.open)
    {
      this.setState({open: this.props.menuStatus});
    }
  }

  componentDidUpdate(prev, next){
    if(this.props.bgSetting === 'dark')
    {
      document.body.style.backgroundColor = "black";
      document.body.style.color = "white";
    }
    else
    {
      document.body.style.backgroundColor = "white";
      document.body.style.color = "#333333";
    }

    if(prev.location.pathname !== this.props.location.pathname)
    {
      this.getTitleName();
    }
  }

  componentWillMount(){
    if(this.props.queryInfo){
      this.props.menuSetting(this.props.queryInfo.q);
    }

    this.updateDimensions();
    this.getTitleName();

  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
    window.removeEventListener('scroll', this.handleScroll)
  }

  updateDimensions(){
    var w = window,
        showDocked = w.innerWidth > 800 ? true : false;
        this.setState({docked: showDocked});
  }

  handleScroll() {
    this.setState({scrollTop: $(window).scrollTop()})
  }

  renderGoTopBtn() {
    const $media_h = $(window).height()

    if (this.state.scrollTop < $media_h) {
      return
    }

    return <div id="goTopBtn" onClick={this.scrollToTop}></div>
  }

  scrollToTop() {
    if (this.state.gotopIsClicked) {
      return
    }

    this.setState({gotopIsClicked: true})

    $('html,body').animate({
      scrollTop: 0
    }, 500,() => {
      this.setState({gotopIsClicked: false})
    })
  }

  handleTouchMap(type) {
    if(type === 'close') {
      this.setState({open: false});
    }else{
      this.setState({open: !this.state.open});
    }
  }

  onActive () {
    if(cookies.get('token')){
      this.setState({autoLogout: true})
      setTimeout(function(){ userLogout() }, 3000)
    }
  }

  onIdle () {}

  resetGroupNum = () => {
    cookies.set('groupNum', 0 , { path: '/' , maxAge: 86400})
  }

  indexBlueBkg() {
    let currentLocation = this.props.location.pathname;
    if(currentLocation == '/' || currentLocation == '/login' || currentLocation == '/profile') {
      return <div className="blueBkg"></div>
    }
  }

  pageBorderColor() {
    let currentLocation = this.props.location.pathname;

    if(currentLocation !== '/login') {
      return 'borderColor';
    }else{
      return '';
    }
  }

  renderAlertMessage() {
    let currentLocation = this.props.location.pathname;
    if(
      currentLocation == '/fananalysis' ||
      currentLocation == '/fanpost' ||
      currentLocation == '/fangroup' ||
      currentLocation == '/loyalty'
    ) {
      return <p className="alert">*因臉書隱私權政策修改，本服務資料僅提供至2018/2/5。</p>;
    }
  }

  checkPermission() {
    if (cookies.get('token')) {
      return (
        <div className="navItemDropdown">
          <ul className="dropdownMenu">
            <li className="dropdownMenuItem">
              <a href="/account">帳戶管理</a>
            </li>
            <li className="dropdownMenuItem">
              <a href="mylist" onClick={() => this.resetGroupNum()}>我的收藏</a>
            </li>
          </ul>
        </div>
      )
    }
  }

  showDatePicker() {
    let currentLocation = this.props.location.pathname;

    if(currentLocation != '/login') {
      return <DatePickerCustom />;
    }
  }

  getTitleName(){
    switch(this.props.location.pathname)
    {
    case "/":
      this.setState({titleName: "KEYDERS 排行榜"});
      break;
    case "/login":
      this.setState({titleName: "登入"});
      break;
    case "/profile":
      this.setState({titleName: "領袖profile"});
      break;
    case "/meta":
      this.setState({titleName: "KOL profile"});
      break;
    case "/account":
      this.setState({titleName: "帳號資訊"});
      break;
    case "/mylist":
      this.setState({titleName: "我的收藏清單"});
      break;
    case "/compare":
      let groupName = ''
      if (this.props.location.query.group_name) {
        groupName = this.props.location.query.group_name + " 排名比較"
        this.setState({titleName: groupName});
      } else {
        this.setState({titleName: "排名比較"});
      }
      break;
    default:
      this.setState({titleName: "登入"});
    }
  }

  render() {
    const hambugerStatus = this.state.open === true ? 'open':''
    return (
      <MuiThemeProvider>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          activeAction={this.onActive}
          idleAction={this.onIdle}
          timeout={this.state.timeout}
          format="MM-DD-YYYY HH:MM:ss.SSS">
          <div>
            <div className="container">
            	<header className={`searchq ${this.props.bgSetting}`}>
                <div className="hamburgerMenu" onClick={()=>this.handleTouchMap('toggle')}>
                  <div className={`${hambugerStatus}`} id="nav-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <AppBar className="appHeader" showMenuIconButton={false}>
                  <div className="logoWrapper">
                    <Link to="/" className="logo"></Link>
                    <p className="logoDes">網路意見領袖搜尋引擎</p>
                  </div>
                  {this.checkPermission()}
                </AppBar>
            	</header>
              <VerticalNavbar openSide={this.state.open} handleTouchMap={this.handleTouchMap}/>
            	<article className="main">
                <div className="pageTitle">
                  {this.renderAlertMessage()}
                  <h2>{this.state.titleName}</h2>
                </div>
                {/*<Drawer className='drawer' containerStyle={{height: 'calc(100% - 90px)', top: 90}} style={{width:'300px'}} docked={false} open={this.state.open}  onRequestChange={(open) => this.setState({open})}>
                  <MenuCustom />
                </Drawer>*/}
            		<div className={`contentWrapper ${this.pageBorderColor()}`}>{this.props.children}</div>
            	</article>
              {this.renderGoTopBtn()}
              <Dialog
                title="閒置時間過久"
                open={this.state.autoLogout}
                style={{zIndex:'10001'}}
              >
                閒置時間已超過1小時，自動登出中
              </Dialog>
              <footer className="footer">
                <p>Copyright © 2018 - {moment().format('YYYY')} 大數據股份有限公司 All rights reserved | <a href="https://news.big-data.tw/privacy-policies/" target="_blank">隱私權政策</a> | <a href="https://news.big-data.tw/information-security/" target="_blank">資訊安全政策</a></p>
              </footer>
              <NotificationContainer/>
            </div>
          </div>
        </IdleTimer>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps({queryInfo, bgSetting, menuStatus}) {
  return { queryInfo, bgSetting, menuStatus }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_queryInfo, menuSetting }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/app.js